import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import get from 'lodash/get';

import {
  ExtendedFlex,
  Formatters,
} from '../../coreui';

import DashboardSection from './DashboardSection';
import ReitIContent from './ReitIContent';
import ReitIIContent from './ReitIIContent';

export const getReitData = (data, asArray = false) => {
  const autoinvestConfigs = get(data, 'autoinvestConfigs') || [];
  const gotData = get(data, 'activeInvestmentsData.reitData.reits') || [];

  const reitData = {
    reitIData: {
      ...gotData.find(item => item.title === 'MogulREIT I'),
      autoinvestConfigs: autoinvestConfigs.filter(item => item.io.label === 'MogulREIT I'),
    },
    reitIIData: {
      ...gotData.find(item => item.title === 'MogulREIT II'),
      autoinvestConfigs: autoinvestConfigs.filter(item => item.io.label === 'MogulREIT II'),
    },
  };

  return asArray ? [reitData.reitIData, reitData.reitIIData] : reitData;
};

const Reits = ({ data }) => {
  if (data.activeInvestmentsData.reitData === undefined) {
    return null;
  }

  const totalInvested = data.activeInvestmentsData.reitData !== undefined ?
    data.activeInvestmentsData.reitData.summary.items.totalInvested.value : 0;
  const formattedTI = data.activeInvestmentsData !== undefined ?
    numeral(totalInvested).format(Formatters.DOLLARS_DECIMALS) : 0;
  const currentValue = data.activeInvestmentsData.reitData !== undefined ?
    data.activeInvestmentsData.reitData.summary.items.currentValue.value : 0;
  const formattedTD = data.activeInvestmentsData.reitData !== undefined ?
    numeral(currentValue).format(Formatters.DOLLARS_DECIMALS) : 0;
  const allocation = data.activeInvestmentsData.reitData !== undefined ?
    data.activeInvestmentsData.reitData.summary.items.portfolioAllocation.value : 0;

  const reitData = getReitData(data);

  return (
    <ExtendedFlex
      flexDirection="column"
      width={1}
      alignItems="center"
    >
      <DashboardSection
        totalInvested={formattedTI}
        currentValue={formattedTD}
        title="REITS"
        allocation={allocation}
      >
        <ReitIContent
          data={reitData.reitIData}
        />
        <ReitIIContent
          data={reitData.reitIIData}
        />
      </DashboardSection>
    </ExtendedFlex>
  );
};

Reits.propTypes = {
  data: PropTypes.object,
};

export default Reits;
